import React from 'react';

function mediaKind(file) {
    if (file.mimetype?.startsWith('image/')) return 'image';
    if (file.mimetype?.startsWith('video/')) return 'video';
    if (file.mimetype?.startsWith('audio/')) return 'audio';
    if (file.mimetype === 'application/pdf') return 'pdf';
    return 'file';
}

function isBrowserPreviewableImage(file) {
    return [
        'image/avif',
        'image/gif',
        'image/jpeg',
        'image/png',
        'image/svg+xml',
        'image/webp',
    ].includes(file.mimetype);
}

const icons = {
    image: 'fa-file-image',
    video: 'fa-file-video',
    audio: 'fa-file-audio',
    pdf: 'fa-file-pdf',
    file: 'fa-file',
};

export default function MediaCard({
    file,
    selected,
    attached = false,
    selectable,
    onEdit,
    onSelect,
}) {
    const kind = mediaKind(file);
    const label = file.title || file.filename;
    const imageUrl = `${file.cdnUrl}?w=480&h=360&etag=${file.etag || file.uuid}`;
    // In multi-select pickers an already-attached file toggles back off when clicked.
    const selectVerb = attached ? 'Remove' : 'Select';

    return (
        <div className={`media-system-card ${selected ? 'is-selected' : ''} ${attached ? 'is-attached' : ''}`}>
            <button
                type="button"
                className="media-system-card-preview"
                onClick={() => selectable ? onSelect(file) : onEdit(file)}
                aria-label={`${selectable ? selectVerb : 'Edit'} ${label}`}
            >
                {kind === 'image' && isBrowserPreviewableImage(file) ? (
                    <img src={imageUrl} alt={file.metadata?.altText || label} />
                ) : (
                    <span className={`media-system-file-icon is-${kind}`}>
                        <i className={`far ${icons[kind]}`} aria-hidden="true"></i>
                        <small>{file.extension?.toUpperCase() || kind.toUpperCase()}</small>
                    </span>
                )}
                {selected && (
                    <span className="media-system-selected-badge">
                        <i className="fas fa-check" aria-hidden="true"></i>
                        {' '}{attached ? 'Added' : 'Selected'}
                    </span>
                )}
            </button>
            <div className="media-system-card-info">
                <strong title={label}>{label}</strong>
                <span>{file.mimetype || 'Unknown file type'}</span>
                <div className="media-system-card-actions">
                    {selectable && (
                        <button
                            type="button"
                            className={`button small ${attached ? 'secondary' : ''}`}
                            onClick={() => onSelect(file)}
                        >
                            {selectVerb}
                        </button>
                    )}
                    <button
                        type="button"
                        className="button small secondary"
                        onClick={() => onEdit(file)}
                    >
                        Edit
                    </button>
                </div>
            </div>
        </div>
    );
}

export {isBrowserPreviewableImage, mediaKind};
